import { render, staticRenderFns } from "./HealthReportIcon.vue?vue&type=template&id=22ee6218"
import script from "./HealthReportIcon.vue?vue&type=script&lang=ts"
export * from "./HealthReportIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports